/* ===========================================================================
 * CART LINK FIX
 * ---------------------------------------------------------------------------
 * PROBLEMA
 *   Os botoes de +/- quantidade e o "remover" do mini-carrinho sao links:
 *     <a href="/cart/change?line=1&quantity=0">
 *
 *   O tema intercepta esse clique na fase de BOLHA (delegacao no elemento
 *   <line-item-quantity>) e faz a atualizacao via AJAX.
 *
 *   O pixel da Utmify registra listener em cada <a> na fase de CAPTURA e
 *   classifica como "link de checkout" qualquer href que contenha a palavra
 *   "cart". O href acima contem. Quando ele nao identifica que esta numa loja
 *   Shopify, ele chama stopPropagation() + preventDefault() e navega na mao
 *   com window.location.href.
 *
 *   Resultado: o handler AJAX do tema nunca roda, e o navegador vai direto
 *   para /cart/change?... , caindo numa tela de erro.
 *
 * SOLUCAO
 *   Registrar um listener na fase de CAPTURA no proprio `document`. Captura
 *   percorre window -> document -> ... -> elemento alvo, entao este handler
 *   roda ANTES do listener que a Utmify coloca no <a>.
 *
 *   Aqui a gente bloqueia a propagacao (para nenhum terceiro tocar no evento)
 *   e executa a mesma atualizacao AJAX que o tema faria, disparando os mesmos
 *   eventos que o tema usa. O comportamento visual fica identico ao original.
 * ========================================================================= */
(function () {
  'use strict';

  function themeVars() {
    return window.themeVariables || null;
  }

  document.addEventListener('click', function (event) {
    var vars = themeVars();
    if (!vars || !vars.routes) return;

    var anchor = event.target && event.target.closest
      ? event.target.closest('a')
      : null;
    if (!anchor || !anchor.href) return;

    /* Só nos interessam links dentro do seletor de quantidade do carrinho. */
    var holder = anchor.closest('line-item-quantity');
    if (!holder) return;

    /* A partir daqui o clique é nosso: ninguém mais encosta nele. */
    event.preventDefault();
    event.stopPropagation();

    /* Na página /cart o tema faz navegação normal. Mantemos isso. */
    if (vars.settings && vars.settings.pageType === 'cart') {
      window.location.href = anchor.href;
      return;
    }

    updateLine(holder, anchor.href, vars);
  }, true); /* true = fase de captura, roda antes de listeners de terceiros */

  function updateLine(holder, href, vars) {
    var params;

    try {
      params = new URL(href, 'https://' + vars.routes.host).searchParams;
    } catch (e) {
      window.location.href = href; /* fallback seguro */
      return;
    }

    var line = params.get('line');
    var id = params.get('id');
    var quantity = parseInt(params.get('quantity'), 10);

    if (isNaN(quantity)) {
      window.location.href = href;
      return;
    }

    holder.dispatchEvent(new CustomEvent('line-item-quantity:change:start', {
      bubbles: true,
      detail: { newLineQuantity: quantity }
    }));

    fetch(vars.routes.cartChangeUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        id: id,
        quantity: quantity,
        sections: ['mini-cart']
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        holder.dispatchEvent(new CustomEvent('line-item-quantity:change:end', {
          bubbles: true,
          detail: { cart: cart, newLineQuantity: quantity }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            replacementDelay: quantity === 0 ? 600 : 750
          }
        }));
      })
      .catch(function () {
        /* Se a requisição falhar, recarrega o carrinho em vez de travar a UI. */
        window.location.href = vars.routes.cartUrl;
      });
  }
})();
